import { useId } from "react";

/** Soft organic shape used as a background accent. */
export default function Blob({ tone = "#c9a9f0", className = "", style }) {
  const id = useId().replace(/:/g, "");

  return (
    <svg viewBox="0 0 400 400" className={className} style={style} role="presentation" fill="none">
      <defs>
        <radialGradient id={`${id}b`} cx="0.35" cy="0.3" r="0.8">
          <stop offset="0" stopColor={tone} stopOpacity="0.85" />
          <stop offset="1" stopColor={tone} stopOpacity="0.12" />
        </radialGradient>
        <filter id={`${id}f`}>
          <feTurbulence type="fractalNoise" baseFrequency="0.012" numOctaves="2" seed="7" />
          <feDisplacementMap in="SourceGraphic" scale="26" />
        </filter>
      </defs>
      <path
        d="M328 168c22 46 6 108-38 142s-108 30-150-2S86 214 104 166s62-84 110-86 92 42 114 88"
        fill={`url(#${id}b)`}
        filter={`url(#${id}f)`}
      />
    </svg>
  );
}
